import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setActiveSubscriptionId } from '../../../store/slices/subscription';

const Terminology = () => {
  const dispatch = useDispatch();

  const handleSubscriptionClick = () => {
    dispatch(setActiveSubscriptionId(39));
  };

  return (
    <div>
      <Link
        to={'/sub'}
        onClick={handleSubscriptionClick}
        style={{
          textDecoration: 'none',
          fontSize: 28,
          color: 'purple',
        }}
      >
        Demo
      </Link>
    </div>
  );
};

export default Terminology;
